var render = function () {
  var _vm$order$order_numbe, _vm$order, _vm$order$order_numbe2, _vm$order2;
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('div', {
    staticClass: "row page-title-header"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('BreadCrumb', {
    attrs: {
      "parentRouteName": "OrderList",
      "extra-items": _vm.readonly ? [{
        text: (_vm$order$order_numbe = (_vm$order = _vm.order) === null || _vm$order === void 0 ? void 0 : _vm$order.order_number) !== null && _vm$order$order_numbe !== void 0 ? _vm$order$order_numbe : ''
      }] : _vm.isEdit ? [{
        text: (_vm$order$order_numbe2 = (_vm$order2 = _vm.order) === null || _vm$order2 === void 0 ? void 0 : _vm$order2.order_number) !== null && _vm$order$order_numbe2 !== void 0 ? _vm$order$order_numbe2 : '',
        to: 'OrderDetail',
        params: _vm.$route.params.order_id
      }, '編輯訂單'] : ['新增訂單']
    }
  })], 1)]), _c('b-card', [_c('b-overlay', {
    attrs: {
      "show": _vm.showLoading,
      "rounded": "sm"
    }
  }, [_c('div', {
    staticClass: "row mb-3 align-items-center"
  }, [_c('div', {
    staticClass: "col-12 col-xl-2"
  }, [_c('h4', {
    staticClass: "font-weight-bold"
  }, [_vm._v("訂單內容")])])]), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-4 mb-2"
  }, [_vm._v("分店名稱(ID)：" + _vm._s(_vm.order.branch ? _vm.order.branch.name + '(' + _vm.order.branch.id + ')' : ''))])]), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-4"
  }, [_c('b-form-group', {
    attrs: {
      "disabled": _vm.readonly
    }
  }, [_c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "m",
      "content-cols": "12",
      "content-cols-lg": "6",
      "label": "會員姓名",
      "disabled": true
    }
  }, [_c('b-form-input', {
    attrs: {
      "value": _vm.order.customer ? _vm.order.customer.name : ''
    }
  })], 1), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "m",
      "content-cols": "12",
      "content-cols-lg": "6",
      "label": "識別編號",
      "disabled": true
    }
  }, [_c('b-form-input', {
    attrs: {
      "value": _vm.order.customer ? _vm.order.customer.outer_code : ''
    }
  })], 1), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "m",
      "content-cols": "12",
      "content-cols-lg": "6",
      "label": "手機號碼",
      "disabled": true
    }
  }, [_c('b-form-input', {
    attrs: {
      "value": _vm.order.customer ? _vm.order.customer.mobile_phone : ''
    }
  })], 1), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "m",
      "content-cols": "12",
      "content-cols-lg": "6",
      "label": "訂單編號(內部)"
    }
  }, [_c('b-form-input', {
    model: {
      value: _vm.order.order_number,
      callback: function callback($$v) {
        _vm.$set(_vm.order, "order_number", $$v);
      },
      expression: "order.order_number"
    }
  })], 1), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "m",
      "content-cols": "12",
      "content-cols-lg": "6",
      "label": "外部訂單編號"
    }
  }, [_c('b-form-input', {
    model: {
      value: _vm.order.outer_order_number,
      callback: function callback($$v) {
        _vm.$set(_vm.order, "outer_order_number", $$v);
      },
      expression: "order.outer_order_number"
    }
  })], 1), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "m",
      "content-cols": "12",
      "content-cols-lg": "6",
      "label": "外部會員ID"
    }
  }, [_c('b-form-input', {
    model: {
      value: _vm.order.customer_outer_code,
      callback: function callback($$v) {
        _vm.$set(_vm.order, "customer_outer_code", $$v);
      },
      expression: "order.customer_outer_code"
    }
  })], 1), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "m",
      "content-cols": "12",
      "content-cols-lg": "6",
      "label": "訂單狀態"
    }
  }, [_c('b-form-select', {
    attrs: {
      "options": _vm.orderStatusOptions
    },
    model: {
      value: _vm.order.status,
      callback: function callback($$v) {
        _vm.$set(_vm.order, "status", $$v);
      },
      expression: "order.status"
    }
  })], 1), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "m",
      "content-cols": "12",
      "content-cols-lg": "6",
      "label": "付款方式"
    }
  }, [_c('b-form-input', {
    model: {
      value: _vm.order.payment_type,
      callback: function callback($$v) {
        _vm.$set(_vm.order, "payment_type", $$v);
      },
      expression: "order.payment_type"
    }
  })], 1), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "m",
      "content-cols": "12",
      "content-cols-lg": "6",
      "label": "配送方式"
    }
  }, [_c('b-form-input', {
    model: {
      value: _vm.order.delivery_type,
      callback: function callback($$v) {
        _vm.$set(_vm.order, "delivery_type", $$v);
      },
      expression: "order.delivery_type"
    }
  })], 1), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "m",
      "content-cols": "12",
      "content-cols-lg": "6",
      "label": "付款狀態"
    }
  }, [_c('b-form-input', {
    model: {
      value: _vm.order.payment_status,
      callback: function callback($$v) {
        _vm.$set(_vm.order, "payment_status", $$v);
      },
      expression: "order.payment_status"
    }
  })], 1), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "m",
      "content-cols": "12",
      "content-cols-lg": "6",
      "label": "運送狀態"
    }
  }, [_c('b-form-select', {
    attrs: {
      "options": _vm.deliveryStatusOptions
    },
    model: {
      value: _vm.order.delivery_status,
      callback: function callback($$v) {
        _vm.$set(_vm.order, "delivery_status", $$v);
      },
      expression: "order.delivery_status"
    }
  })], 1), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "m",
      "content-cols": "12",
      "content-cols-lg": "6",
      "label": "消費者備註狀態"
    }
  }, [_c('b-form-input', {
    model: {
      value: _vm.order.memo,
      callback: function callback($$v) {
        _vm.$set(_vm.order, "memo", $$v);
      },
      expression: "order.memo"
    }
  })], 1)], 1)], 1), _c('div', {
    staticClass: "col-4"
  }, [_c('b-form-group', {
    attrs: {
      "disabled": _vm.readonly
    }
  }, [_c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "3",
      "label-size": "l",
      "content-cols": "12",
      "content-cols-lg": "8",
      "label": "下單時間"
    }
  }, [_c('div', {
    staticClass: "d-flex"
  }, [_c('div', {
    staticClass: "w-50"
  }, [_c('datepicker', {
    attrs: {
      "bootstrap-styling": "",
      "format": "yyyy-MM-dd",
      "language": _vm.zh
    },
    model: {
      value: _vm.order.order_at.date,
      callback: function callback($$v) {
        _vm.$set(_vm.order.order_at, "date", $$v);
      },
      expression: "order.order_at.date"
    }
  })], 1), _c('div', {
    staticClass: "ml-2 w-50"
  }, [_vm.order.order_at.time ? _c('vue-timepicker', {
    attrs: {
      "format": "HH:mm",
      "input-class": ['form-control'],
      "hide-clear-button": true
    },
    model: {
      value: _vm.order.order_at.time,
      callback: function callback($$v) {
        _vm.$set(_vm.order.order_at, "time", $$v);
      },
      expression: "order.order_at.time"
    }
  }) : _c('b-form-input')], 1)])]), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "3",
      "label-size": "l",
      "content-cols": "12",
      "content-cols-lg": "8",
      "label": "訂單狀態日"
    }
  }, [_c('div', {
    staticClass: "d-flex"
  }, [_c('div', {
    staticClass: "w-50"
  }, [_c('datepicker', {
    attrs: {
      "bootstrap-styling": "",
      "format": "yyyy-MM-dd",
      "language": _vm.zh
    },
    model: {
      value: _vm.order.status_at.date,
      callback: function callback($$v) {
        _vm.$set(_vm.order.status_at, "date", $$v);
      },
      expression: "order.status_at.date"
    }
  })], 1), _c('div', {
    staticClass: "ml-2 w-50"
  }, [_vm.order.status_at.time ? _c('vue-timepicker', {
    attrs: {
      "format": "HH:mm",
      "input-class": ['form-control'],
      "hide-clear-button": true
    },
    model: {
      value: _vm.order.status_at.time,
      callback: function callback($$v) {
        _vm.$set(_vm.order.status_at, "time", $$v);
      },
      expression: "order.status_at.time"
    }
  }) : _c('b-form-input')], 1)])]), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "3",
      "label-size": "l",
      "content-cols": "12",
      "content-cols-lg": "8",
      "label": "訂單確認日期"
    }
  }, [_c('div', {
    staticClass: "d-flex"
  }, [_c('div', {
    staticClass: "w-50"
  }, [_c('datepicker', {
    attrs: {
      "bootstrap-styling": "",
      "format": "yyyy-MM-dd",
      "language": _vm.zh
    },
    model: {
      value: _vm.order.confirm_at.date,
      callback: function callback($$v) {
        _vm.$set(_vm.order.confirm_at, "date", $$v);
      },
      expression: "order.confirm_at.date"
    }
  })], 1), _c('div', {
    staticClass: "ml-2 w-50"
  }, [_vm.order.status_at.time ? _c('vue-timepicker', {
    attrs: {
      "format": "HH:mm",
      "input-class": ['form-control'],
      "hide-clear-button": true
    },
    model: {
      value: _vm.order.confirm_at.time,
      callback: function callback($$v) {
        _vm.$set(_vm.order.confirm_at, "time", $$v);
      },
      expression: "order.confirm_at.time"
    }
  }) : _c('b-form-input')], 1)])]), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "3",
      "label-size": "l",
      "content-cols": "12",
      "content-cols-lg": "8",
      "label": "完成時間"
    }
  }, [_c('div', {
    staticClass: "d-flex"
  }, [_c('div', {
    staticClass: "w-50"
  }, [_c('datepicker', {
    attrs: {
      "bootstrap-styling": "",
      "format": "yyyy-MM-dd",
      "language": _vm.zh
    },
    model: {
      value: _vm.order.completed_at.date,
      callback: function callback($$v) {
        _vm.$set(_vm.order.completed_at, "date", $$v);
      },
      expression: "order.completed_at.date"
    }
  })], 1), _c('div', {
    staticClass: "ml-2 w-50"
  }, [_vm.order.completed_at.time ? _c('vue-timepicker', {
    attrs: {
      "format": "HH:mm",
      "input-class": ['form-control'],
      "hide-clear-button": true
    },
    model: {
      value: _vm.order.completed_at.time,
      callback: function callback($$v) {
        _vm.$set(_vm.order.completed_at, "time", $$v);
      },
      expression: "order.completed_at.time"
    }
  }) : _c('b-form-input')], 1)])]), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "3",
      "label-size": "l",
      "content-cols": "12",
      "content-cols-lg": "8",
      "label": "建立時間"
    }
  }, [_c('div', {
    staticClass: "d-flex"
  }, [_c('div', {
    staticClass: "w-50"
  }, [_c('datepicker', {
    attrs: {
      "placeholder": "Select Date",
      "bootstrap-styling": "",
      "format": "yyyy-MM-dd",
      "language": _vm.zh,
      "disabled": true
    },
    model: {
      value: _vm.order.created_at,
      callback: function callback($$v) {
        _vm.$set(_vm.order, "created_at", $$v);
      },
      expression: "order.created_at"
    }
  })], 1)])]), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "3",
      "label-size": "l",
      "content-cols": "12",
      "content-cols-lg": "8",
      "label": "更新時間"
    }
  }, [_c('div', {
    staticClass: "d-flex"
  }, [_c('div', {
    staticClass: "w-50"
  }, [_c('datepicker', {
    attrs: {
      "placeholder": "Select Date",
      "bootstrap-styling": "",
      "format": "yyyy-MM-dd",
      "language": _vm.zh,
      "disabled": true
    },
    model: {
      value: _vm.order.updated_at,
      callback: function callback($$v) {
        _vm.$set(_vm.order, "updated_at", $$v);
      },
      expression: "order.updated_at"
    }
  })], 1)])]), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "m",
      "content-cols": "12",
      "content-cols-lg": "6",
      "label": "金額小計"
    }
  }, [_c('b-form-input', {
    model: {
      value: _vm.order.sub_total,
      callback: function callback($$v) {
        _vm.$set(_vm.order, "sub_total", $$v);
      },
      expression: "order.sub_total"
    }
  })], 1), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "m",
      "content-cols": "12",
      "content-cols-lg": "6",
      "label": "訂單折扣"
    }
  }, [_c('b-form-input', {
    model: {
      value: _vm.order.order_discount,
      callback: function callback($$v) {
        _vm.$set(_vm.order, "order_discount", $$v);
      },
      expression: "order.order_discount"
    }
  })], 1), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "m",
      "content-cols": "12",
      "content-cols-lg": "6",
      "label": "運費"
    }
  }, [_c('b-form-input', {
    model: {
      value: _vm.order.delivery_fee,
      callback: function callback($$v) {
        _vm.$set(_vm.order, "delivery_fee", $$v);
      },
      expression: "order.delivery_fee"
    }
  })], 1), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "m",
      "content-cols": "12",
      "content-cols-lg": "6",
      "label": "金流費"
    }
  }, [_c('b-form-input', {
    model: {
      value: _vm.order.payment_fee,
      callback: function callback($$v) {
        _vm.$set(_vm.order, "payment_fee", $$v);
      },
      expression: "order.payment_fee"
    }
  })], 1), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "m",
      "content-cols": "12",
      "content-cols-lg": "6",
      "label": "總價(含稅)"
    }
  }, [_c('b-form-input', {
    model: {
      value: _vm.order.total,
      callback: function callback($$v) {
        _vm.$set(_vm.order, "total", $$v);
      },
      expression: "order.total"
    }
  })], 1)], 1)], 1)]), _c('div', {
    staticClass: "row mt-4 align-items-center"
  }, [_c('div', {
    staticClass: "col-12 col-xl-2"
  }, [_c('h4', {
    staticClass: "font-weight-bold"
  }, [_vm._v("訂單明細")])])]), !_vm.readonly ? _c('div', {
    staticClass: "text-right"
  }, [false ? _c('b-button', {
    staticClass: "flex-shrink-0 mb-2 mb-xl-0 ml-2 py-2",
    attrs: {
      "variant": "primary"
    },
    on: {
      "click": _vm.addItemHandler
    }
  }, [_c('i', {
    staticClass: "fa fa-plus",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("新增商品 ")]) : _vm._e()], 1) : _vm._e(), _c('b-table', {
    staticClass: "order-detail-table",
    attrs: {
      "striped": "",
      "hover": "",
      "responsive": "",
      "items": _vm.order.items,
      "fields": _vm.fields,
      "busy": _vm.showLoading
    },
    scopedSlots: _vm._u([{
      key: "cell(outer_order_item_number)",
      fn: function fn(data) {
        return [_c('span', {
          staticClass: "text-truncate-cell",
          attrs: {
            "id": "popover-order-item-".concat(data.index)
          }
        }, [_vm._v(" " + _vm._s(data.item.outer_order_item_number) + " ")]), data.item.outer_order_item_number ? _c('b-popover', {
          attrs: {
            "target": "popover-order-item-".concat(data.index),
            "triggers": "hover focus",
            "placement": "right"
          }
        }, [_c('div', {
          staticClass: "text-left"
        }, [_vm._v(_vm._s(data.item.outer_order_item_number))])]) : _vm._e()];
      }
    }, {
      key: "cell(title)",
      fn: function fn(data) {
        return [_c('span', {
          staticClass: "text-truncate-cell",
          attrs: {
            "id": "popover-title-".concat(data.index)
          }
        }, [_vm._v(" " + _vm._s(data.item.title) + " ")]), data.item.title ? _c('b-popover', {
          attrs: {
            "target": "popover-title-".concat(data.index),
            "triggers": "hover focus",
            "placement": "right"
          }
        }, [_c('div', {
          staticClass: "text-left"
        }, [_vm._v(_vm._s(data.item.title))])]) : _vm._e()];
      }
    }, {
      key: "cell(sku_name)",
      fn: function fn(data) {
        return [_c('span', {
          staticClass: "text-truncate-cell",
          attrs: {
            "id": "popover-sku-name-".concat(data.index)
          }
        }, [_vm._v(" " + _vm._s(data.item.sku_name) + " ")]), data.item.sku_name ? _c('b-popover', {
          attrs: {
            "target": "popover-sku-name-".concat(data.index),
            "triggers": "hover focus",
            "placement": "right"
          }
        }, [_c('div', {
          staticClass: "text-left"
        }, [_vm._v(_vm._s(data.item.sku_name))])]) : _vm._e()];
      }
    }, {
      key: "cell(sku_code)",
      fn: function fn(data) {
        return [_c('span', {
          staticClass: "text-truncate-cell",
          attrs: {
            "id": "popover-sku-code-".concat(data.index)
          }
        }, [_vm._v(" " + _vm._s(data.item.sku_code) + " ")]), data.item.sku_code ? _c('b-popover', {
          attrs: {
            "target": "popover-sku-code-".concat(data.index),
            "triggers": "hover focus",
            "placement": "right"
          }
        }, [_c('div', {
          staticClass: "text-left"
        }, [_vm._v(_vm._s(data.item.sku_code))])]) : _vm._e()];
      }
    }, {
      key: "cell(sku_serial_number)",
      fn: function fn(data) {
        return [_c('span', {
          staticClass: "text-truncate-cell",
          attrs: {
            "id": "popover-sku-serial-".concat(data.index)
          }
        }, [_vm._v(" " + _vm._s(data.item.sku_serial_number) + " ")]), data.item.sku_serial_number ? _c('b-popover', {
          attrs: {
            "target": "popover-sku-serial-".concat(data.index),
            "triggers": "hover focus",
            "placement": "right"
          }
        }, [_c('div', {
          staticClass: "text-left"
        }, [_vm._v(_vm._s(data.item.sku_serial_number))])]) : _vm._e()];
      }
    }, {
      key: "cell(name)",
      fn: function fn(data) {
        return [_vm.readonly ? _c('div', [_vm._v(" " + _vm._s(data.item.sku_name) + " " + _vm._s(data.item.sku_code) + " ")]) : _c('div', [_c('b-form-group', {
          attrs: {
            "label-cols": "12",
            "label-cols-sm": "3",
            "label-size": "sm",
            "content-cols": "6",
            "content-cols-sm": "6",
            "label": "商品名稱"
          }
        }, [_c('b-form-input', {
          model: {
            value: data.item.sku_name,
            callback: function callback($$v) {
              _vm.$set(data.item, "sku_name", $$v);
            },
            expression: "data.item.sku_name"
          }
        })], 1), _c('b-form-group', {
          attrs: {
            "label-cols": "12",
            "label-cols-sm": "3",
            "label-size": "sm",
            "content-cols": "6",
            "content-cols-sm": "6",
            "label": "商品編號"
          }
        }, [_c('b-form-input', {
          model: {
            value: data.item.sku_code,
            callback: function callback($$v) {
              _vm.$set(data.item, "sku_code", $$v);
            },
            expression: "data.item.sku_code"
          }
        })], 1)], 1)];
      }
    }, {
      key: "cell(price)",
      fn: function fn(data) {
        return [_vm.readonly ? _c('div', [_vm._v(" " + _vm._s(data.item.price) + " ")]) : _c('div', [_c('b-form-group', {
          attrs: {
            "label-cols": "12",
            "label-cols-sm": "0",
            "label-size": "sm",
            "content-cols": "12",
            "content-cols-sm": "12"
          }
        }, [_c('b-form-input', {
          attrs: {
            "type": "number"
          },
          model: {
            value: data.item.price,
            callback: function callback($$v) {
              _vm.$set(data.item, "price", $$v);
            },
            expression: "data.item.price"
          }
        })], 1)], 1)];
      }
    }, {
      key: "cell(quantity)",
      fn: function fn(data) {
        return [_vm.readonly ? _c('div', [_vm._v(" " + _vm._s(data.item.quantity) + " ")]) : _c('div', [_c('b-form-group', {
          attrs: {
            "label-cols": "12",
            "label-cols-sm": "0",
            "label-size": "sm",
            "content-cols": "12",
            "content-cols-sm": "12"
          }
        }, [_c('b-form-input', {
          attrs: {
            "type": "number"
          },
          model: {
            value: data.item.quantity,
            callback: function callback($$v) {
              _vm.$set(data.item, "quantity", $$v);
            },
            expression: "data.item.quantity"
          }
        })], 1)], 1)];
      }
    }, {
      key: "cell(total_price)",
      fn: function fn(data) {
        return [_vm.readonly ? _c('div', [_vm._v(" " + _vm._s(data.item.total_price) + " ")]) : _c('div', [_c('b-form-group', {
          attrs: {
            "label-cols": "12",
            "label-cols-sm": "0",
            "label-size": "sm",
            "content-cols": "12",
            "content-cols-sm": "12"
          }
        }, [_c('b-form-input', {
          attrs: {
            "type": "number"
          },
          model: {
            value: data.item.total_price,
            callback: function callback($$v) {
              _vm.$set(data.item, "total_price", $$v);
            },
            expression: "data.item.total_price"
          }
        })], 1)], 1)];
      }
    }, {
      key: "cell(total_discount)",
      fn: function fn(data) {
        return [_vm.readonly ? _c('div', [_vm._v(" " + _vm._s(data.item.total_discount) + " ")]) : _c('div', [_c('b-form-group', {
          attrs: {
            "label-cols": "12",
            "label-cols-sm": "0",
            "label-size": "sm",
            "content-cols": "6",
            "content-cols-sm": "6"
          }
        }, [_c('b-form-input', {
          attrs: {
            "type": "number"
          },
          model: {
            value: data.item.total_discount,
            callback: function callback($$v) {
              _vm.$set(data.item, "total_discount", $$v);
            },
            expression: "data.item.total_discount"
          }
        })], 1)], 1)];
      }
    }, {
      key: "cell(total_payment)",
      fn: function fn(data) {
        return [_vm.readonly ? _c('div', [_vm._v(" " + _vm._s(data.item.total_payment) + " ")]) : _c('div', [_c('b-form-group', {
          attrs: {
            "label-cols": "12",
            "label-cols-sm": "0",
            "label-size": "sm",
            "content-cols": "6",
            "content-cols-sm": "6"
          }
        }, [_c('b-form-input', {
          attrs: {
            "type": "number"
          },
          model: {
            value: data.item.total_payment,
            callback: function callback($$v) {
              _vm.$set(data.item, "total_payment", $$v);
            },
            expression: "data.item.total_payment"
          }
        })], 1)], 1)];
      }
    }, {
      key: "cell(status)",
      fn: function fn(data) {
        return [_vm.readonly ? _c('div', [_vm._v(" " + _vm._s(data.item.status) + " ")]) : _c('div', [_c('b-form-group', {
          attrs: {
            "label-cols": "12",
            "label-cols-sm": "0",
            "label-size": "sm",
            "content-cols": "6",
            "content-cols-sm": "6",
            "label": "訂單狀態"
          }
        }, [_c('b-form-select', {
          attrs: {
            "options": _vm.orderStatusOptions
          },
          model: {
            value: data.item.status,
            callback: function callback($$v) {
              _vm.$set(data.item, "status", $$v);
            },
            expression: "data.item.status"
          }
        })], 1)], 1), _c('div', [_vm._v(" " + _vm._s(_vm.format(new Date(data.item.status_at), "yyyy-MM-dd HH:mm")) + " ")]), _c('div', [_vm._v(" " + _vm._s(_vm.format(new Date(data.item.confirm_at), "yyyy-MM-dd HH:mm")) + " ")])];
      }
    }, {
      key: "cell(delivery)",
      fn: function fn(data) {
        return [_vm.readonly ? _c('div', [_vm._v(" " + _vm._s(data.item.delivery_status) + " " + _vm._s(data.item.delivery_type) + " " + _vm._s(data.item.delivery_shipping_code) + " ")]) : _c('div', [_c('b-form-group', {
          attrs: {
            "label-cols": "12",
            "label-cols-sm": "0",
            "label-size": "sm",
            "content-cols": "6",
            "content-cols-sm": "6",
            "label": "配送狀態"
          }
        }, [_c('b-form-select', {
          attrs: {
            "options": _vm.deliveryStatusOptions
          },
          model: {
            value: data.item.delivery_status,
            callback: function callback($$v) {
              _vm.$set(data.item, "delivery_status", $$v);
            },
            expression: "data.item.delivery_status"
          }
        })], 1), _c('b-form-group', {
          attrs: {
            "label-cols": "12",
            "label-cols-sm": "0",
            "label-size": "sm",
            "content-cols": "6",
            "content-cols-sm": "6",
            "label": "配送方式"
          }
        }, [_c('b-form-input', {
          model: {
            value: data.item.delivery_type,
            callback: function callback($$v) {
              _vm.$set(data.item, "delivery_type", $$v);
            },
            expression: "data.item.delivery_type"
          }
        })], 1), _c('b-form-group', {
          attrs: {
            "label-cols": "12",
            "label-cols-sm": "0",
            "label-size": "sm",
            "content-cols": "6",
            "content-cols-sm": "6",
            "label": "貨運單配送編號"
          }
        }, [_c('b-form-input', {
          model: {
            value: data.item.delivery_shipping_code,
            callback: function callback($$v) {
              _vm.$set(data.item, "delivery_shipping_code", $$v);
            },
            expression: "data.item.delivery_shipping_code"
          }
        })], 1)], 1)];
      }
    }, {
      key: "cell(return)",
      fn: function fn(data) {
        return [_vm.readonly ? _c('div', {
          staticStyle: {
            "color": "red"
          }
        }, [_vm._v(" " + _vm._s(data.item.return_shipping_code) + " " + _vm._s(data.item.return_shipping_id) + " " + _vm._s(data.item.return_status) + " ")]) : _c('div', {
          staticStyle: {
            "color": "red"
          }
        }, [_c('b-form-group', {
          attrs: {
            "label-cols": "12",
            "label-cols-sm": "0",
            "label-size": "sm",
            "content-cols": "6",
            "content-cols-sm": "6",
            "label": "退貨運單配送編號"
          }
        }, [_c('b-form-input', {
          model: {
            value: data.item.return_shipping_code,
            callback: function callback($$v) {
              _vm.$set(data.item, "return_shipping_code", $$v);
            },
            expression: "data.item.return_shipping_code"
          }
        })], 1), _c('b-form-group', {
          attrs: {
            "label-cols": "12",
            "label-cols-sm": "0",
            "label-size": "sm",
            "content-cols": "6",
            "content-cols-sm": "6",
            "label": "退貨運單配送id"
          }
        }, [_c('b-form-input', {
          model: {
            value: data.item.return_shipping_id,
            callback: function callback($$v) {
              _vm.$set(data.item, "return_shipping_id", $$v);
            },
            expression: "data.item.return_shipping_id"
          }
        })], 1), _c('b-form-group', {
          attrs: {
            "label-cols": "12",
            "label-cols-sm": "0",
            "label-size": "sm",
            "content-cols": "6",
            "content-cols-sm": "6",
            "label": "退貨狀態"
          }
        }, [_c('b-form-input', {
          model: {
            value: data.item.return_status,
            callback: function callback($$v) {
              _vm.$set(data.item, "return_status", $$v);
            },
            expression: "data.item.return_status"
          }
        })], 1)], 1)];
      }
    }, {
      key: "cell(processed_memo)",
      fn: function fn(data) {
        return [_c('div', {
          staticClass: "d-flex flex-column align-items-center"
        }, [data.item.processed_memo ? _c('span', {
          directives: [{
            name: "b-modal",
            rawName: "v-b-modal.modal-memo-view",
            modifiers: {
              "modal-memo-view": true
            }
          }],
          staticClass: "mdi mdi-coin",
          staticStyle: {
            "cursor": "pointer",
            "font-size": "1.5rem"
          },
          attrs: {
            "id": "popover-points-".concat(data.item.id)
          },
          on: {
            "click": function click($event) {
              _vm.modalTitle = '入點說明', _vm.modalContent = data.item.processed_memo;
            }
          }
        }) : _vm._e(), data.item.processed_memo ? _c('b-popover', {
          attrs: {
            "target": "popover-points-".concat(data.item.id),
            "triggers": "hover focus"
          }
        }, [_c('div', {
          staticClass: "text-left"
        }, [_vm._v("點擊，觀看『入點說明』")])]) : _vm._e()], 1)];
      }
    }, !_vm.readonly ? {
      key: "cell(arrange)",
      fn: function fn(data) {
        return [_c('b-button', {
          staticClass: "delete-button",
          attrs: {
            "variant": "danger"
          },
          on: {
            "click": function click($event) {
              return _vm.removeItemHandler(data.index);
            }
          }
        }, [_vm._v("刪除商品")])];
      }
    } : null], null, true)
  }), !_vm.readonly ? _c('div', {
    staticClass: "d-flex justify-content-center",
    staticStyle: {
      "margin-top": "80px"
    }
  }, [_c('b-button', {
    staticClass: "mr-4",
    attrs: {
      "variant": "outline-danger"
    },
    on: {
      "click": _vm.handleCancel
    }
  }, [[_vm._v("返回")]], 2), _c('b-button', {
    attrs: {
      "variant": "success"
    },
    on: {
      "click": _vm.handleSubmit
    }
  }, [_vm.isEdit ? [_vm._v("確認編輯")] : _vm._e(), _vm.isCreate ? [_vm._v("確認新增")] : _vm._e()], 2)], 1) : _vm._e()], 1)], 1), _c('b-modal', {
    attrs: {
      "id": "modal-memo-view",
      "title": _vm.modalTitle
    },
    scopedSlots: _vm._u([{
      key: "modal-footer",
      fn: function fn(_ref) {
        var cancel = _ref.cancel;
        return [_c('b-button', {
          staticClass: "float-right",
          attrs: {
            "variant": "outline-danger",
            "size": "sm"
          },
          on: {
            "click": function click($event) {
              return cancel();
            }
          }
        }, [_vm._v(" 關閉 ")])];
      }
    }])
  }, [_c('div', {
    staticClass: "p-3",
    staticStyle: {
      "white-space": "pre-wrap",
      "max-height": "400px",
      "overflow-y": "auto"
    }
  }, [_vm._v(_vm._s(_vm.modalContent))])])], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }